var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SimpleLayout',[_c('SellingStepsExplanation')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }